"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getAttendeePresenceFunc = require("./getAttendeePresenceFunc");
Object.keys(_getAttendeePresenceFunc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getAttendeePresenceFunc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getAttendeePresenceFunc[key];
    }
  });
});
var _onPresenceChangedHandler = require("./onPresenceChangedHandler");
Object.keys(_onPresenceChangedHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _onPresenceChangedHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _onPresenceChangedHandler[key];
    }
  });
});